import React, { useEffect, useState } from "react";
import ReactSwitch from "react-switch";
import Swal from "sweetalert2";
import { apiRequest } from "../../apiServices/allApi";
import "../../../assets/css/Dashboard.css";

export const Sitesettings = () => {
  // Game Settings
  const [gameSearch, setGameSearch] = useState(false);
  const [isBots, setIsBots] = useState(false);
  const [totalBotsCount, setTotalBotsCount] = useState(20);
  const [isLudokingClassic, setIsLudokingClassic] = useState(false);
  const [roomcode, setRoomcode] = useState(false);
  const [amountMin, setAmountMin] = useState(50);
  const [amountMax, setAmountMax] = useState(50000);

  // User & KYC Settings
  const [userCanLogin, setUserCanLogin] = useState(false);
  const [userSignup, setUserSignup] = useState(true);
  const [onlineKYC, setOnlineKYC] = useState(false);
  const [offlineKYC, setOfflineKYC] = useState(false);
  const [siteMaintenance, setSiteMaintenance] = useState(true);

  // Referral / Commission Settings
  const [isReferral, setIsReferral] = useState(true);
  const [referralCommission, setReferralCommission] = useState(7);
  const [commissionRange1, setCommissionRange1] = useState(7);
  const [commissionRange2, setCommissionRange2] = useState(5);
  const [commissionRange3, setCommissionRange3] = useState(2);

  // Deposit Settings
  const [isDeposit, setIsDeposit] = useState(false);
  const [depositlimitMin, setDepositlimitMin] = useState(10);
  const [depositlimitMax, setDepositlimitMax] = useState(500);
  const [whatsappDepositmsg, setWhatsappDepositmsg] = useState("");
  const [depositGuide, setDepositGuide] = useState("");

  // Withdrawal Settings
  const [isWithdrawal, setIsWithdrawal] = useState(false);
  const [isUpiWithdrawal, setIsUpiWithdrawal] = useState(false);
  const [isBankWithdrawal, setIsBankWithdrawal] = useState(false);
  const [isQrWithdrawal, setIsQrWithdrawal] = useState(false);
  const [withdrawalLimitMin, setWithdrawalLimitMin] = useState(95);
  const [withdrawalLimitMax, setWithdrawalLimitMax] = useState(500);
  const [withdrawalLimitMinQr, setWithdrawalLimitMinQr] = useState(95);
  const [withdrawalLimitMaxQr, setWithdrawalLimitMaxQr] = useState(500);
  const [withdrawalLimitMinUpi, setWithdrawalLimitMinUpi] = useState(95);
  const [withdrawalLimitMaxUpi, setWithdrawalLimitMaxUpi] = useState(500);
  const [withdrawalLimitMinBank, setWithdrawalLimitMinBank] = useState(95);
  const [withdrawalLimitMaxBank, setWithdrawalLimitMaxBank] = useState(500);
  const [autoWithdrawalLimitMax, setAutoWithdrawalLimitMax] = useState(100);
  const [withdrawTime, setWithdrawTime] = useState("");
  const [withdraw_message, setWithdrawMessage] = useState("");

  // Branding & Info Settings
  const [WebTitle, setWebTitle] = useState("");
  const [WebsiteName, setWebsiteName] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyAddress, setCompanyAddress] = useState("");
  const [CompanyMobile, setCompanyMobile] = useState("");
  const [Logo, setLogo] = useState(null);
  const [currentLogoUrl, setCurrentLogoUrl] = useState("");
  const [version, setVersion] = useState("");

  // Messages & Support Settings
  const [site_message, setSiteMessage] = useState("");
  const [ludoClassicAutobattleMsg, setLudoClassicAutobattleMsg] = useState("");
  const [ludoClassicManualMsg, setLudoClassicManualMsg] = useState("");
  const [supportMail, setSupportMail] = useState("");
  const [supportInstagram, setSupportInstagram] = useState("");
  const [supportTelegram, setSupportTelegram] = useState("");
  const [whatsappSupport, setWhatsappSupport] = useState("");

  const [loader, setLoader] = useState(true);
  const userType = localStorage.getItem("user");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    // Branding & Info
    formData.append("WebTitle", WebTitle || "");
    formData.append("WebsiteName", WebsiteName || "");
    formData.append("CompanyName", CompanyName || "");
    formData.append("CompanyAddress", CompanyAddress || "");
    formData.append("CompanyMobile", CompanyMobile || "");
    if (Logo && typeof Logo !== "string") {
      formData.append("Logo", Logo);
    }
    formData.append("version", version || "");

    // Game Settings
    formData.append("gameSearch", gameSearch);
    formData.append("isBots", isBots);
    formData.append("totalBotsCount", totalBotsCount);
    formData.append("isLudokingClassic", isLudokingClassic);
    formData.append("roomcode", roomcode);
    formData.append("amountMin", amountMin);
    formData.append("amountMax", amountMax);

    // User & KYC
    formData.append("userCanLogin", userCanLogin);
    formData.append("userSignup", userSignup);
    formData.append("onlineKYC", onlineKYC);
    formData.append("offlineKYC", offlineKYC);
    formData.append("siteMaintenance", siteMaintenance);

    // Referral / Commission
    formData.append("isReferral", isReferral);
    formData.append("referralCommission", referralCommission);
    formData.append("commissionRange1", commissionRange1);
    formData.append("commissionRange2", commissionRange2);
    formData.append("commissionRange3", commissionRange3);

    // Deposit
    formData.append("isDeposit", isDeposit);
    formData.append("depositlimitMin", depositlimitMin);
    formData.append("depositlimitMax", depositlimitMax);
    formData.append("whatsappDepositmsg", whatsappDepositmsg || "");
    formData.append("depositGuide", depositGuide || "");

    // Withdrawal
    formData.append("isWithdrawal", isWithdrawal);
    formData.append("isUpiWithdrawal", isUpiWithdrawal);
    formData.append("isBankWithdrawal", isBankWithdrawal);
    formData.append("isQrWithdrawal", isQrWithdrawal);
    formData.append("withdrawalLimitMin", withdrawalLimitMin);
    formData.append("withdrawalLimitMax", withdrawalLimitMax);
    formData.append("withdrawalLimitMinQr", withdrawalLimitMinQr);
    formData.append("withdrawalLimitMaxQr", withdrawalLimitMaxQr);
    formData.append("withdrawalLimitMinUpi", withdrawalLimitMinUpi);
    formData.append("withdrawalLimitMaxUpi", withdrawalLimitMaxUpi);
    formData.append("withdrawalLimitMinBank", withdrawalLimitMinBank);
    formData.append("withdrawalLimitMaxBank", withdrawalLimitMaxBank);
    formData.append("autoWithdrawalLimitMax", autoWithdrawalLimitMax);
    formData.append("withdrawTime", withdrawTime);
    formData.append("withdraw_message", withdraw_message || "");

    // Messages & Support
    formData.append("site_message", site_message || "");
    formData.append("ludoClassicAutobattleMsg", ludoClassicAutobattleMsg || "");
    formData.append("ludoClassicManualMsg", ludoClassicManualMsg || "");
    formData.append("supportMail", supportMail || "");
    formData.append("supportInstagram", supportInstagram || "");
    formData.append("supportTelegram", supportTelegram || "");
    formData.append("supportWhatsapp", whatsappSupport || "");
    formData.append("whatsappSupport", whatsappSupport || "");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest("settings", "POST", formData, headers);
      if (res.data?.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Settings Updated",
          text: "Website settings saved successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Could not update settings. Please try again.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while saving settings.",
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        const result = await apiRequest("settings/data", "GET", null);
        const data = result?.data;
        if (data) {
          // Branding & Info
          setWebTitle(data.WebTitle ?? "");
          setWebsiteName(data.WebsiteName ?? "");
          setCompanyName(data.CompanyName ?? "");
          setCompanyAddress(data.CompanyAddress ?? "");
          setCompanyMobile(data.CompanyMobile ?? "");
          setCurrentLogoUrl(data.Logo ?? "");
          setVersion(data.version ?? "");

          // Game Settings
          setGameSearch(Boolean(data.gameSearch));
          setIsBots(Boolean(data.isBots));
          setTotalBotsCount(data.totalBotsCount ?? 20);
          setIsLudokingClassic(Boolean(data.isLudokingClassic));
          setRoomcode(Boolean(data.roomcode));
          setAmountMin(data.amountMin ?? 50);
          setAmountMax(data.amountMax ?? 50000);

          // User & KYC
          setUserCanLogin(Boolean(data.userCanLogin));
          setUserSignup(
            typeof data.userSignup !== "undefined"
              ? Boolean(data.userSignup)
              : true,
          );
          setOnlineKYC(Boolean(data.onlineKYC));
          setOfflineKYC(Boolean(data.offlineKYC));
          setSiteMaintenance(
            typeof data.siteMaintenance !== "undefined"
              ? Boolean(data.siteMaintenance)
              : true,
          );

          // Referral / Commission
          setIsReferral(
            typeof data.isReferral !== "undefined"
              ? Boolean(data.isReferral)
              : true,
          );
          setReferralCommission(data.referralCommission ?? 7);
          setCommissionRange1(data.commissionRange1 ?? 7);
          setCommissionRange2(data.commissionRange2 ?? 5);
          setCommissionRange3(data.commissionRange3 ?? 2);

          // Deposit
          setIsDeposit(Boolean(data.isDeposit));
          setDepositlimitMin(data.depositlimitMin ?? 10);
          setDepositlimitMax(data.depositlimitMax ?? 500);
          setWhatsappDepositmsg(data.whatsappDepositmsg ?? "");
          setDepositGuide(data.depositGuide ?? "");

          // Withdrawal
          setIsWithdrawal(Boolean(data.isWithdrawal));
          setIsUpiWithdrawal(Boolean(data.isUpiWithdrawal));
          setIsBankWithdrawal(Boolean(data.isBankWithdrawal));
          setIsQrWithdrawal(Boolean(data.isQrWithdrawal));
          setWithdrawalLimitMin(data.withdrawalLimitMin ?? 95);
          setWithdrawalLimitMax(data.withdrawalLimitMax ?? 500);
          setWithdrawalLimitMinQr(data.withdrawalLimitMinQr ?? 95);
          setWithdrawalLimitMaxQr(data.withdrawalLimitMaxQr ?? 500);
          setWithdrawalLimitMinUpi(data.withdrawalLimitMinUpi ?? 95);
          setWithdrawalLimitMaxUpi(data.withdrawalLimitMaxUpi ?? 500);
          setWithdrawalLimitMinBank(data.withdrawalLimitMinBank ?? 95);
          setWithdrawalLimitMaxBank(data.withdrawalLimitMaxBank ?? 500);
          setAutoWithdrawalLimitMax(data.autoWithdrawalLimitMax ?? 100);
          setWithdrawTime(data.withdrawTime ?? "");
          setWithdrawMessage(data.withdraw_message ?? "");

          // Messages & Support
          setSiteMessage(data.site_message ?? "");
          setLudoClassicAutobattleMsg(data.ludoClassicAutobattleMsg ?? "");
          setLudoClassicManualMsg(data.ludoClassicManualMsg ?? "");
          setSupportMail(data.supportMail ?? "");
          setSupportInstagram(data.supportInstagram ?? "");
          setSupportTelegram(data.supportTelegram ?? "");
          setWhatsappSupport(data.whatsappSupport ?? "");
        }
      } catch (error) {
        console.error("Error fetching site settings:", error);
      } finally {
        setLoader(false);
      }
    };

    fetchData();
  }, []);

  return loader ? (
    null
  ) : (
    <div className="admin-main-card mt-4 mb-5">
      <div className="admin-card-header">
        <h4 className="admin-card-title">
          <i className="mdi mdi-cogs text-primary"></i> Website & Global
          Platform Settings
        </h4>
        <span className="badge badge-primary px-3 py-2">
          Master Configuration
        </span>
      </div>

      <div className="card-body p-4 bg-white">
        <form
          onSubmit={handleSubmit}
          method="post"
          encType="multipart/form-data"
        >
          {userType === "Admin" && (
            <>
              {/* SECTION 1: GAME CONTROLS */}
              <div className="settings-section-title">
                <i className="mdi mdi-gamepad-variant text-primary"></i> Game &
                Battle Configuration
              </div>
              <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                  <div className="settings-box-card">
                    <div className="settings-box-header">
                      <i className="mdi mdi-tune text-info"></i> Game Controls
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">Game Search</label>
                      <ReactSwitch
                        checked={gameSearch}
                        onChange={setGameSearch}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        AI Bots Integration
                      </label>
                      <ReactSwitch
                        checked={isBots}
                        onChange={setIsBots}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">Total Bots Count</label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={totalBotsCount}
                        onChange={(e) => setTotalBotsCount(e.target.value)}
                        placeholder="20"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Ludo King Classic
                      </label>
                      <ReactSwitch
                        checked={isLudokingClassic}
                        onChange={setIsLudokingClassic}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">Room Code System</label>
                      <ReactSwitch
                        checked={roomcode}
                        onChange={setRoomcode}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 mb-3">
                  <div className="settings-box-card">
                    <div className="settings-box-header">
                      <i className="mdi mdi-cash-multiple text-warning"></i>{" "}
                      Battle Amount Limits
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Minimum Battle Amount (₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={amountMin}
                        onChange={(e) => setAmountMin(e.target.value)}
                        placeholder="50"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Maximum Battle Amount (₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={amountMax}
                        onChange={(e) => setAmountMax(e.target.value)}
                        placeholder="50000"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* SECTION 2: USER & KYC CONTROLS */}
              <div className="settings-section-title">
                <i className="mdi mdi-account-cog text-success"></i> User Access
                & KYC Verification
              </div>
              <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                  <div className="settings-box-card">
                    <div className="settings-box-header">
                      <i className="mdi mdi-account-key text-success"></i>{" "}
                      Access & Maintenance
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">Allow User Login</label>
                      <ReactSwitch
                        checked={userCanLogin}
                        onChange={setUserCanLogin}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Allow New Registrations
                      </label>
                      <ReactSwitch
                        checked={userSignup}
                        onChange={setUserSignup}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Site Maintenance Mode
                      </label>
                      <ReactSwitch
                        checked={siteMaintenance}
                        onChange={setSiteMaintenance}
                        onColor="#ef4444"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 mb-3">
                  <div className="settings-box-card">
                    <div className="settings-box-header">
                      <i className="mdi mdi-card-account-details text-primary"></i>{" "}
                      KYC Verification Methods
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Online KYC (Automated API)
                      </label>
                      <ReactSwitch
                        checked={onlineKYC}
                        onChange={setOnlineKYC}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Offline KYC (Manual Admin Review)
                      </label>
                      <ReactSwitch
                        checked={offlineKYC}
                        onChange={setOfflineKYC}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* SECTION 3: REFERRAL & COMMISSIONS */}
              <div className="settings-section-title">
                <i className="mdi mdi-share-variant text-warning"></i> Referral
                & Commissions
              </div>
              <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                  <div className="settings-box-card">
                    <div className="settings-box-header">
                      <i className="mdi mdi-gift text-warning"></i> Referral
                      System
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">Referral Enabled</label>
                      <ReactSwitch
                        checked={isReferral}
                        onChange={setIsReferral}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Referral Commission (%)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={referralCommission}
                        onChange={(e) => setReferralCommission(e.target.value)}
                        placeholder="7"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Commission Range 1 (%)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={commissionRange1}
                        onChange={(e) => setCommissionRange1(e.target.value)}
                        placeholder="7"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Commission Range 2 (Flat ₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={commissionRange2}
                        onChange={(e) => setCommissionRange2(e.target.value)}
                        placeholder="5"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Commission Range 3 (%)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={commissionRange3}
                        onChange={(e) => setCommissionRange3(e.target.value)}
                        placeholder="2"
                      />
                    </div>
                  </div>
                </div>

                {/* SECTION 4: DEPOSIT CONFIG */}
                <div className="col-lg-6 mb-3">
                  <div className="settings-box-card">
                    <div className="settings-box-header">
                      <i className="mdi mdi-arrow-down-bold-box text-success"></i>{" "}
                      Deposit Controls
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        User Deposit Enabled
                      </label>
                      <ReactSwitch
                        checked={isDeposit}
                        onChange={setIsDeposit}
                        onColor="#0284c7"
                        offColor="#cbd5e1"
                        height={24}
                        width={48}
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Minimum Deposit Limit (₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={depositlimitMin}
                        onChange={(e) => setDepositlimitMin(e.target.value)}
                        placeholder="10"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Maximum Deposit Limit (₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={depositlimitMax}
                        onChange={(e) => setDepositlimitMax(e.target.value)}
                        placeholder="500"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        WhatsApp Deposit Message
                      </label>
                      <input
                        type="text"
                        className="form-control settings-input-sm"
                        value={whatsappDepositmsg}
                        onChange={(e) => setWhatsappDepositmsg(e.target.value)}
                        placeholder="Deposit msg"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">Video Guide URL</label>
                      <input
                        type="url"
                        className="form-control settings-input-sm"
                        value={depositGuide}
                        onChange={(e) => setDepositGuide(e.target.value)}
                        placeholder="https://..."
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* SECTION 5: WITHDRAWAL CONTROLS */}
          <div className="settings-section-title">
            <i className="mdi mdi-arrow-up-bold-box text-danger"></i> Withdrawal
            Configurations
          </div>
          <div className="row mb-4">
            {/* General Withdrawal Controls */}
            <div className="col-12 mb-3">
              <div className="settings-box-card">
                <div className="settings-box-header">
                  <i className="mdi mdi-tune text-primary"></i> General
                  Withdrawal Controls
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    {userType === "Admin" && (
                      <div className="settings-row">
                        <label className="settings-label">
                          Global Withdrawal Enabled
                        </label>
                        <ReactSwitch
                          checked={isWithdrawal}
                          onChange={setIsWithdrawal}
                          onColor="#0284c7"
                          offColor="#cbd5e1"
                          height={24}
                          width={48}
                        />
                      </div>
                    )}
                    <div className="settings-row">
                      <label className="settings-label">
                        Auto Withdrawal Threshold (₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={autoWithdrawalLimitMax}
                        onChange={(e) =>
                          setAutoWithdrawalLimitMax(e.target.value)
                        }
                        placeholder="100"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Default Min Withdrawal (₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={withdrawalLimitMin}
                        onChange={(e) => setWithdrawalLimitMin(e.target.value)}
                        placeholder="95"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="settings-row">
                      <label className="settings-label">
                        Hold Delay Time (Minutes)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={
                          withdrawTime ? Number(withdrawTime) / (60 * 1000) : ""
                        }
                        onChange={(e) => {
                          const minutes = parseFloat(e.target.value);
                          setWithdrawTime(
                            isNaN(minutes) ? "" : minutes * 60 * 1000,
                          );
                        }}
                        placeholder="Minutes"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Withdraw Notice Message
                      </label>
                      <input
                        type="text"
                        className="form-control settings-input-sm"
                        value={withdraw_message}
                        onChange={(e) => setWithdrawMessage(e.target.value)}
                        placeholder="Notice to users"
                      />
                    </div>
                    <div className="settings-row">
                      <label className="settings-label">
                        Default Max Withdrawal (₹)
                      </label>
                      <input
                        type="number"
                        className="form-control settings-input-sm"
                        value={withdrawalLimitMax}
                        onChange={(e) => setWithdrawalLimitMax(e.target.value)}
                        placeholder="500"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 1: Bank Withdrawal */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="settings-box-card">
                <div className="settings-box-header">
                  <i className="mdi mdi-bank text-primary"></i> 1. Bank
                  Withdrawal
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    Direct Bank Withdrawal
                  </label>
                  <ReactSwitch
                    checked={isBankWithdrawal}
                    onChange={setIsBankWithdrawal}
                    onColor="#0284c7"
                    offColor="#cbd5e1"
                    height={24}
                    width={48}
                  />
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    Bank Min Withdrawal (₹)
                  </label>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={withdrawalLimitMinBank}
                    onChange={(e) => setWithdrawalLimitMinBank(e.target.value)}
                    placeholder="95"
                  />
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    Bank Max Withdrawal (₹)
                  </label>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={withdrawalLimitMaxBank}
                    onChange={(e) => setWithdrawalLimitMaxBank(e.target.value)}
                    placeholder="500"
                  />
                </div>
              </div>
            </div>

            {/* Section 2: UPI Withdrawal */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="settings-box-card">
                <div className="settings-box-header">
                  <i className="mdi mdi-cellphone-wireless text-success"></i> 2.
                  UPI Withdrawal
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    UPI Withdrawal Gateway
                  </label>
                  <ReactSwitch
                    checked={isUpiWithdrawal}
                    onChange={setIsUpiWithdrawal}
                    onColor="#0284c7"
                    offColor="#cbd5e1"
                    height={24}
                    width={48}
                  />
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    UPI Min Withdrawal (₹)
                  </label>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={withdrawalLimitMinUpi}
                    onChange={(e) => setWithdrawalLimitMinUpi(e.target.value)}
                    placeholder="95"
                  />
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    UPI Max Withdrawal (₹)
                  </label>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={withdrawalLimitMaxUpi}
                    onChange={(e) => setWithdrawalLimitMaxUpi(e.target.value)}
                    placeholder="500"
                  />
                </div>
              </div>
            </div>

            {/* Section 3: QR Code Withdrawal */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="settings-box-card">
                <div className="settings-box-header">
                  <i className="mdi mdi-qrcode-scan text-warning"></i> 3. QR
                  Code Withdrawal
                </div>
                <div className="settings-row">
                  <label className="settings-label">QR Code Withdrawal</label>
                  <ReactSwitch
                    checked={isQrWithdrawal}
                    onChange={setIsQrWithdrawal}
                    onColor="#0284c7"
                    offColor="#cbd5e1"
                    height={24}
                    width={48}
                  />
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    QR Min Withdrawal (₹)
                  </label>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={withdrawalLimitMinQr}
                    onChange={(e) => setWithdrawalLimitMinQr(e.target.value)}
                    placeholder="95"
                  />
                </div>
                <div className="settings-row">
                  <label className="settings-label">
                    QR Max Withdrawal (₹)
                  </label>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={withdrawalLimitMaxQr}
                    onChange={(e) => setWithdrawalLimitMaxQr(e.target.value)}
                    placeholder="500"
                  />
                </div>
              </div>
            </div>
          </div>

          {userType === "Admin" && (
            <>
              {/* SECTION 6: BRANDING & COMPANY DETAILS */}
              <div className="settings-section-title">
                <i className="mdi mdi-domain text-info"></i> Branding & Platform
                Details
              </div>
              <div className="settings-box-card mb-4 p-4">
                <div className="row">
                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">Website Title</label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={WebTitle}
                      onChange={(e) => setWebTitle(e.target.value)}
                      placeholder="e.g. Ludo Empire"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">Website Name</label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={WebsiteName}
                      onChange={(e) => setWebsiteName(e.target.value)}
                      placeholder="e.g. LudoEmpire.com"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      Company / Organization Name
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={CompanyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                      placeholder="e.g. Game Innovations Private Ltd"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      Official Contact Number
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={CompanyMobile}
                      onChange={(e) => setCompanyMobile(e.target.value)}
                      placeholder="+91 9876543210"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      Registered Address
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={CompanyAddress}
                      onChange={(e) => setCompanyAddress(e.target.value)}
                      placeholder="Street, City, State"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      App / Build Version
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={version}
                      onChange={(e) => setVersion(e.target.value)}
                      placeholder="e.g. 1.2.0"
                    />
                  </div>

                  <div className="form-group col-md-6 mb-3">
                    <label className="settings-label mb-2">Website Logo</label>
                    <input
                      className="form-control form-control-light"
                      type="file"
                      name="Logo"
                      accept="image/*"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          setLogo(e.target.files[0]);
                        }
                      }}
                    />
                    {currentLogoUrl && (
                      <div className="mt-2 text-muted small">
                        Current Logo:{" "}
                        <span className="text-primary font-weight-bold">
                          {currentLogoUrl}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* SECTION 7: ANNOUNCEMENTS & SUPPORT */}
              <div className="settings-section-title">
                <i className="mdi mdi-bullhorn text-cyan"></i> In-App
                Announcements & Support Channels
              </div>
              <div className="settings-box-card mb-4 p-4">
                <div className="row">
                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      Home Message
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={site_message}
                      onChange={(e) => setSiteMessage(e.target.value)}
                      placeholder="Important platform update notice"
                    />
                  </div>
                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      Manual Challenge Notice
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={ludoClassicManualMsg}
                      onChange={(e) => setLudoClassicManualMsg(e.target.value)}
                      placeholder="Notice for manual games"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">battle Notice</label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={ludoClassicAutobattleMsg}
                      onChange={(e) =>
                        setLudoClassicAutobattleMsg(e.target.value)
                      }
                      placeholder="Notice for autobattles"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">Support Email</label>
                    <input
                      className="form-control form-control-light"
                      type="email"
                      value={supportMail}
                      onChange={(e) => setSupportMail(e.target.value)}
                      placeholder="support@example.com"
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      Instagram Profile URL
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="url"
                      value={supportInstagram}
                      onChange={(e) => setSupportInstagram(e.target.value)}
                      placeholder="https://instagram.com/..."
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      Telegram Channel / Support
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="url"
                      value={supportTelegram}
                      onChange={(e) => setSupportTelegram(e.target.value)}
                      placeholder="https://t.me/..."
                    />
                  </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="settings-label mb-2">
                      WhatsApp Support Link / Number
                    </label>
                    <input
                      className="form-control form-control-light"
                      type="text"
                      value={whatsappSupport}
                      onChange={(e) => setWhatsappSupport(e.target.value)}
                      placeholder="+91..."
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* SUBMIT BUTTON */}
          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-primary-gradient px-5 py-3"
            >
              <i className="mdi mdi-content-save mr-2"></i> Save All Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Sitesettings;
